import { useState, useEffect } from "react";
import { CalendarDays } from "lucide-react";

const DAYS = ["S", "M", "T", "W", "T", "F", "S"];
const MONTHS = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
];

const CalendarWidget = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const iv = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(iv);
  }, []);

  const year = now.getFullYear();
  const month = now.getMonth();
  const today = now.getDate();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div
      data-testid="calendar-widget"
      className="bg-gray-950/80 border border-cyan-500/20 rounded-sm p-3 flex flex-col gap-2"
    >
      {/* Header */}
      <div className="flex items-center gap-1.5 border-b border-cyan-500/15 pb-2">
        <CalendarDays className="w-3 h-3 text-cyan-400 shrink-0" />
        <span className="font-heading text-[10px] tracking-[0.15em] uppercase text-cyan-300">CAL</span>
        <span className="font-mono text-[8px] tracking-wider text-cyan-600 ml-auto">
          {MONTHS[month]} {year}
        </span>
      </div>

      {/* Day headers */}
      <div className="grid grid-cols-7 gap-0">
        {DAYS.map((d, i) => (
          <div
            key={i}
            className="font-mono text-[8px] text-center text-cyan-600 py-0.5"
          >
            {d}
          </div>
        ))}
      </div>

      {/* Date cells */}
      <div className="grid grid-cols-7 gap-0">
        {cells.map((day, i) => (
          <div
            key={i}
            className={`font-mono text-[9px] text-center py-[3px] rounded-sm ${
              day === today
                ? "bg-cyan-500/30 text-cyan-200 font-bold shadow-[0_0_6px_rgba(6,182,212,0.4)]"
                : day
                ? "text-cyan-500/60"
                : ""
            }`}
          >
            {day || ""}
          </div>
        ))}
      </div>

      {/* Current time */}
      <div className="pt-1.5 border-t border-cyan-500/10 font-mono text-[9px] text-center tracking-[0.2em] text-cyan-500">
        {now.toLocaleTimeString("en-US", { hour12: false })}
      </div>
    </div>
  );
};

export default CalendarWidget;
